import { ProperCasePipe } from '../../shared/pipes/proper-case.pipe';

export function properCase ( properCasePipe : ProperCasePipe ) {
  return ( value : string ) : string => properCasePipe.transform(value);
}
